// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Caml_option from "../../../../../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as AuthTextModuleScss from "../../styles/AuthText.module.scss";

var styles = AuthTextModuleScss;

function AuthTextCmp(Props) {
  var heading = Props.heading;
  var sub_heading = Props.sub_heading;
  var stylesOpt = Props.styles;
  var styles$1 = stylesOpt !== undefined ? Caml_option.valFromOption(stylesOpt) : styles;
  return React.createElement("div", {
              className: styles$1["text-wrapper"]
            }, React.createElement("p", {
                  className: styles$1.heading
                }, heading), sub_heading !== undefined ? React.createElement("p", {
                    className: styles$1["sub-heading"]
                  }, sub_heading) : null);
}

var make = AuthTextCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
